module.exports = __webpack_public_path__ + "img/elementlengths_jakp.15f03ab3.png";